export const versions = {
  version: "1.0.183",
  revision: "91cd06071",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5082-g91cd06071-dirty",
    hash: "g91cd06071",
    distance: 5082,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5082-g91cd06071-dirty",
    semverString: "1.0.183+5082.g91cd06071.dirty"
  }
};
